import React from 'react'
import Svg from './Svg'
export const SvgExit = React.forwardRef(({ size, ...props }, svgRef) => (
  <Svg viewBox="0 0 24 24" height={size} width={size} fill="currentColor" ref={svgRef} {...props}>
    <path d="M18.894 14.912v-2.983h-7.456V8.947h7.456V5.965l4.473 4.473zm-1.491-1.492v5.965H9.947v4.474L1 19.385V0h16.403v7.456h-1.491V1.491H3.982l5.965 2.982v13.421h5.965V13.42z" />
  </Svg>
))
SvgExit.isIcon = true
export default SvgExit
